import React, { useRef, useState } from 'react';
import classNames from 'classnames/bind';
import useOnClickOutside from 'common/hooks/useOnClickOutside';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './AccountSelect.module.scss';

export interface IAccountOption {
  value: string | number;
  reference: string | number;
  balance: string | number;
  profileId: string | number;
}

interface Props {
  optionsList: IAccountOption[];
  selectedOption?: any;
  noShadow?: boolean;
  onChange: (value: any) => void;
}

const AccountSelect = ({
  optionsList,
  selectedOption,
  noShadow,
  onChange,
}: Props) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const selectRef: any = useRef();

  const handleClick = () => {
    setShowOptions(!showOptions);
  };

  const handleClickOutside = () => {
    setShowOptions(false);
  };

  useOnClickOutside(selectRef, handleClickOutside);

  return (
    <div className={styles.wrapper}>
      <div className={styles.selectWrapper}>
        <select
          ref={selectRef}
          onClick={handleClick}
          onChange={(e) => onChange(e.target.value)}
          className={classNames(styles.select, noShadow && styles.noShadow)}
        >
          {(optionsList || []).map((acc: IAccountOption, index: number) => (
            <option
              key={index}
              value={acc.value}
              selected={selectedOption === acc.profileId}
            >
              {acc.reference} {acc.balance && `- ${acc.balance}`}
            </option>
          ))}
        </select>
        <Icon
          type={SvgIcons.CHEVRON_ICON}
          width={7}
          className={classNames(styles.icon, showOptions && styles.expanded)}
        />
      </div>

      {/* {LayoutModel?.ShowTotalBalanceForAllProfiles && (
        <p className="Text Text--finePrint Selectaccount-text">
          {LayoutModel.Settings.TotalBalanceForProfilesLabel}{' '}
          {LayoutModel?.FormattedCurrencyShowTotalBalanceForAllProfiles}
        </p>
      )} */}
    </div>
  );
};

export default AccountSelect;
